/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `1D` - 1D
 * * `2D` - 2D
 * * `1D2D` - 1D2D
 * * `GW` - Groundwater
 * @export
 */
export const SubsetsEnum = {
  _1D: "1D",
  _2D: "2D",
  _1D2D: "1D2D",
  GW: "GW",
} as const;
export type SubsetsEnum = (typeof SubsetsEnum)[keyof typeof SubsetsEnum];

export function instanceOfSubsetsEnum(value: any): boolean {
  for (const key in SubsetsEnum) {
    if (Object.prototype.hasOwnProperty.call(SubsetsEnum, key)) {
      if (SubsetsEnum[key as keyof typeof SubsetsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SubsetsEnumFromJSON(json: any): SubsetsEnum {
  return SubsetsEnumFromJSONTyped(json, false);
}

export function SubsetsEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubsetsEnum {
  return json as SubsetsEnum;
}

export function SubsetsEnumToJSON(value?: SubsetsEnum | null): any {
  return value as any;
}

export function SubsetsEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SubsetsEnum {
  return value as SubsetsEnum;
}
